import React from "react";
import {
  Bâtiment,
  Espace,
  Niveau,
  Parcelle,
  Piece,
  Site,
} from "../../interfaces";
import {
  ModalAddSite,
  ModalAddBâtiment,
  ModalAddEspace,
  ModalAddNiveau,
  ModalAddPiece,
} from "../../components";

interface ActionPanelSiteProps {
  openModal: (modalName: string, site?: Site) => void;
  closeModal: (modalName: string, site?: Site) => void;
  sites: Site[];
  parcelles: Parcelle[];
  batiments: Bâtiment[];
  niveaux: Niveau[];
  espaces: Espace[];
  modals: any;
}

const ActionPanelSite = ({
  openModal,
  closeModal,
  sites,
  parcelles,
  batiments,
  niveaux,
  espaces,
  modals,
}: ActionPanelSiteProps) => {
  return (
    <>
      <div className="items-center  border-r border-gray-200  gap-x-3">
        <div className="flex flex-col mr-12  space-y-10">
          <button
            onClick={() => openModal("site")}
            className="flex justify-center w-1/2 px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
          >
            <img
              src="images/plus.png"
              className="inline-block h-3 mr-3 mt-1 flex-none"
              alt="plus"
            />
            Site
          </button>
          <hr />
          <button
            onClick={() => openModal("bâtiment")}
            className="flex justify-center w-1/2 px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
          >
            <img
              src="images/plus.png"
              className="inline-block h-3 mr-3 mt-1 flex-none"
              alt="plus"
            />
            Bâtiment
          </button>
          <button
            onClick={() => openModal("niveau")}
            className="flex justify-center w-1/2 px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
          >
            <img
              src="images/plus.png"
              className="inline-block h-3 mr-3 mt-1 flex-none"
              alt="plus"
            />
            Niveau
          </button>
          <button
            onClick={() => openModal("espace")}
            className="flex justify-center w-1/2 px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
          >
            <img
              src="images/plus.png"
              className="inline-block h-3 mr-3 mt-1 flex-none"
              alt="plus"
            />
            Espace
          </button>
          <button
            onClick={() => openModal("pièce")}
            className="flex justify-center w-1/2 px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
          >
            <img
              src="images/plus.png"
              className="inline-block h-3 mr-3 mt-1 flex-none"
              alt="plus"
            />
            Pièce
          </button>
        </div>
      </div>
      <ModalAddSite
        modalIsOpenSite={modals.site}
        closeModalSite={() => closeModal("site")}
        parcelles={parcelles}
      />
      <ModalAddBâtiment
        modalIsOpenBatiment={modals.bâtiment}
        closeModalBatiment={() => closeModal("bâtiment")}
        sites={sites}
      />
      <ModalAddNiveau
        modalIsOpenNiveau={modals.niveau}
        closeModalNiveau={() => closeModal("niveau")}
        batiments={batiments}
        sites={sites}
      />
      <ModalAddEspace
        modalIsOpenEspace={modals.espace}
        closeModalEspace={() => closeModal("espace")}
        niveaux={niveaux}
        sites={sites}
        batiments={batiments}
      />
      <ModalAddPiece
        modalIsOpenPiece={modals.pièce}
        closeModalPiece={() => closeModal("pièce")}
        espaces={espaces}
        batiments={batiments}
        sites={sites}
        niveaux={niveaux}
      />
    </>
  );
};

export default ActionPanelSite;
